export const INITIAL_STATE = {
  centers: null,
  searchCenters: null,
  donorCenters: null,
  selectedCenters: null,
  appointmentSlot: null,
  slotsForDonor: null,
  slotsForAppointment: null,
  nearbyCenters: null,
  centerStatus: null,
  createApplicationUser: null,
  favouriteCenters: null,

  getDonorCenterInfoLoading: false,
  getDonorCenterInfoSuccess: null,
  getDonorCenterInfoFailure: null,

  getFavoriteCenterInfoLoading: false,
  getFavoriteCenterInfoSuccess: null,
  getFavoriteCenterInfoFailure: null,

  updateFavoriteCenterLoading: false,
  updateFavoriteCenterSuccess: null,
  updateFavoriteCenterFailure: null,

  getAllCentersLoading: false,
  getAllCentersSuccess: null,
  getAllCentersFailure: null,

  getZipcodeSearchCentersLoading: false,
  getZipcodeSearchCentersSuccess: null,
  getZipcodeSearchCentersFailure: null,

  getAppointmentCenterLoading: false,
  getAppointmentCenterSuccess: null,
  getAppointmentCenterFailure: null,

  searchCentersLoading: false,
  searchCentersSuccess: null,
  searchCentersFailure: null,

  getDonorCentersAllLoading: false,
  getDonorCentersAllSuccess: null,
  getDonorCentersAllFailure: null,

  getStateCentersLoading: false,
  getStateCentersSuccess: null,
  getStateCentersFailure: null,

  registerGetCentersLoading: false,
  registerGetCentersSuccess: null,
  registerGetCentersFailure: null,

  getAppointmentSlotLoading: false,
  getAppointmentSlotSuccess: null,
  getAppointmentSlotFailure: null,

  addAppointmentSlotLoading: false,
  addAppointmentSlotSuccess: null,
  addAppointmentSlotFailure: null,

  getSlotsForAppointmentTypeLoading: false,
  getSlotsForAppointmentTypeSuccess: null,
  getSlotsForAppointmentTypeFailure: null,

  getSlotsForDonorLoading: false,
  getSlotsForDonorSuccess: null,
  getSlotsForDonorFailure: null,

  // NEW

  getAppointmentReportLoading: false,
  getAppointmentReportSuccess: null,
  getAppointmentReportFailure: null,

  downloadReportLoading: false,
  downloadReportSuccess: null,
  downloadReportFailure: null,

  getCenterCalendarLoading: false,
  getCenterCalendarSuccess: null,
  getCenterCalendarFailure: null,

  getAlternateDonorCentersInfoLoading: false,
  getAlternateDonorCentersInfoSuccess: null,
  getAlternateDonorCentersInfoFailure: null,

  getCenterInfoLoading: false,
  getCenterInfoSuccess: null,
  getCenterInfoFailure: null,

  createApplicationUserLoading: false,
  createApplicationUserSuccess: null,
  createApplicationUserFailure: null,

  searchApplicationUserLoading: false,
  searchApplicationUserSuccess: null,
  searchApplicationUserFailure: null,

  getApplicationUserDetailsLoading: false,
  getApplicationUserDetailsSuccess: null,
  getApplicationUserDetailsFailure: null,

  editApplicationUserLoading: false,
  editApplicationUserSuccess: null,
  editApplicationUserFailure: null,

  removeUserCenterAccessLoading: false,
  removeUserCenterAccessSuccess: null,
  removeUserCenterAccessFailure: null,

  updateUserDefaultCenterLoading: false,
  updateUserDefaultCenterSuccess: null,
  updateUserDefaultCenterFailure: null,

  removeUserPortalAccessLoading: false,
  removeUserPortalAccessSuccess: null,
  removeUserPortalAccessFailure: null,

  addUserCenterAccessLoading: false,
  addUserCenterAccessSuccess: null,
  addUserCenterAccessFailure: null,
};
